import type { Code } from 'mdast';

import type { Node as PMNode } from '@atlaskit/editor-prosemirror/model';

export function codeBlock(node: PMNode): Code {
	let value = '';
	node.forEach((child) => {
		if (child.isText) {
			value += child.text;
		}
	});
	const result: Code = { type: 'code', value };
	const lang = node.attrs.language ?? node.attrs.lang;
	if (lang) {
		result.lang = lang as string;
	}
	return result;
}
